import { setPlatformMuted } from '../audio/soundSettings';
import type { CrazyGamesSdkLike, CrazyGamesSettingsListener } from './crazyGamesSdk';

let crazyGamesMuted = false;
let adBreakMuted = false;
let boundSdk: CrazyGamesSdkLike | null = null;
let boundListener: CrazyGamesSettingsListener | null = null;

function publishPlatformMute(): void {
  setPlatformMuted(crazyGamesMuted || adBreakMuted);
}

function readMuteAudio(sdk: CrazyGamesSdkLike, settings?: { muteAudio?: boolean }): boolean {
  if (typeof settings?.muteAudio === 'boolean') {
    return settings.muteAudio;
  }
  return Boolean(sdk.game.settings?.muteAudio);
}

/** Apply CrazyGames `muteAudio` before playback and keep it in priority over the user Sound toggle. */
export function bindCrazyGamesPlatformAudio(sdk: CrazyGamesSdkLike): void {
  if (boundListener && boundSdk?.game.removeSettingsChangeListener) {
    boundSdk.game.removeSettingsChangeListener(boundListener);
  }
  boundSdk = sdk;
  boundListener = null;
  crazyGamesMuted = readMuteAudio(sdk);
  publishPlatformMute();
  if (!sdk.game.addSettingsChangeListener) {
    return;
  }
  const listener: CrazyGamesSettingsListener = (settings) => {
    crazyGamesMuted = readMuteAudio(sdk, settings);
    publishPlatformMute();
  };
  boundListener = listener;
  sdk.game.addSettingsChangeListener(listener);
}

/** Missing, disabled, or failed SDK leaves platform mute off. */
export function noteCrazyGamesAudioUnavailable(): void {
  crazyGamesMuted = false;
  publishPlatformMute();
}

/** Rewarded-ad mute overlays platform mute and must not clear `muteAudio` when the ad ends. */
export function setAdBreakPlatformMuted(muted: boolean): void {
  adBreakMuted = muted;
  publishPlatformMute();
}

export function resetCrazyGamesAudioForTests(): void {
  if (boundListener && boundSdk?.game.removeSettingsChangeListener) {
    boundSdk.game.removeSettingsChangeListener(boundListener);
  }
  boundListener = null;
  boundSdk = null;
  crazyGamesMuted = false;
  adBreakMuted = false;
  setPlatformMuted(false);
}
